import React, { useEffect, useState } from 'react';
import { companyAdminAPI } from '../../lib/walletApi';
import { Card, CardContent } from '../../components/ui/card';
import { Heart, Loader2 } from 'lucide-react';

export default function CompanyBenefits() {
  const [elections, setElections] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { companyAdminAPI.getElections().then(d => setElections(Array.isArray(d) ? d : [])).catch(() => {}).finally(() => setLoading(false)); }, []);
  if (loading) return <div className="flex justify-center py-20"><Loader2 className="w-8 h-8 animate-spin text-pink-400" /></div>;
  return (
    <div className="space-y-6" data-testid="company-benefits">
      <div><h1 className="text-xl font-bold text-gray-900">Benefit Elections</h1><p className="text-sm text-gray-500">{elections.length} elections</p></div>
      <div className="space-y-2">
        {elections.map(e => (
          <Card key={e.id} className="border-gray-200 shadow-sm"><CardContent className="p-3 flex items-center justify-between">
            <div className="flex items-center gap-3"><div className="w-8 h-8 rounded-lg bg-pink-50 text-pink-600 flex items-center justify-center"><Heart className="w-4 h-4" /></div><div><p className="text-sm font-medium text-gray-900">{e.category}</p><p className="text-xs text-gray-400">NGN {Number(e.amount || 0).toLocaleString()}/month</p></div></div>
            <span className={`text-[10px] px-2 py-0.5 rounded-full font-medium ${e.status === 'active' ? 'bg-emerald-50 text-emerald-600' : 'bg-gray-100 text-gray-500'}`}>{e.status}</span>
          </CardContent></Card>
        ))}
        {elections.length === 0 && <Card className="border-gray-200"><CardContent className="p-8 text-center text-gray-400 text-sm">No benefit elections</CardContent></Card>}
      </div>
    </div>
  );
}
